type BrandProps = {
  compact?: boolean
}

export function Brand({ compact = false }: BrandProps) {
  return (
    <div className={'brand ' + (compact ? 'brand--compact' : '')} aria-label="無駄いい MUDAII">
      <img className="brand__logo brand__logo--light" src="/brand/logo-light.webp" alt="無駄いい MUDAII" />
      <img className="brand__logo brand__logo--dark" src="/brand/logo-dark.webp" alt="" aria-hidden="true" />
    </div>
  )
}
